<template>
  <div class="container py-5">
    <div class="row">
      <div class="col-md-8 mx-auto">
        <div class="card">
          <div class="card-header bg-primary text-white">
            <h4 class="mb-0">Informations générales</h4>
          </div>
          <div class="card-body">
            <form @submit.prevent="updateProfile">
              <!-- Informations de base (non modifiables) -->
              <div class="mb-4">
                <h5>Informations de base</h5>
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Nom</label>
                      <input type="text" class="form-control" :value="user.last_name" disabled>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Prénom</label>
                      <input type="text" class="form-control" :value="user.first_name" disabled>
                    </div>
                  </div>
                </div>
                <div class="row mt-3">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Email</label>
                      <input type="email" class="form-control" :value="user.email" disabled>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Téléphone</label>
                      <input type="tel" class="form-control" :value="user.phone" disabled>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Informations complémentaires -->
              <div class="mb-4">
                <h5>Informations complémentaires</h5>
                <div class="form-group mb-3">
                  <label>Date de naissance</label>
                  <input 
                    type="date" 
                    class="form-control" 
                    v-model="formData.date_naissance"
                    :class="{ 'is-invalid': errors.date_naissance }"
                  >
                  <div class="invalid-feedback">{{ errors.date_naissance }}</div>
                </div>

                <div class="form-group mb-3">
                  <label>Adresse</label>
                  <textarea 
                    class="form-control" 
                    v-model="formData.adresse"
                    rows="2"
                    :class="{ 'is-invalid': errors.adresse }"
                  ></textarea>
                  <div class="invalid-feedback">{{ errors.adresse }}</div>
                </div>

                <div class="form-group mb-3">
                  <label>Présentation</label>
                  <small class="text-muted d-block mb-2">
                    Veuillez décrire vos points forts, points d'amélioration, votre vision de l'employé idéal, ainsi que vos diplômes et expériences pertinents.
                  </small>
                  <textarea 
                    class="form-control" 
                    v-model="formData.presentation"
                    rows="4"
                    :class="{ 'is-invalid': errors.presentation }"
                    placeholder="Points forts:
Points d'amélioration:
Employé idéal:
Diplômes et expériences pertinents:"
                  ></textarea>
                  <div class="invalid-feedback">{{ errors.presentation }}</div>
                </div>

                <div class="form-group mb-3">
                  <label>Disponibilité</label>
                  <textarea 
                    class="form-control" 
                    v-model="formData.disponibilite"
                    rows="2"
                    :class="{ 'is-invalid': errors.disponibilite }"
                  ></textarea>
                  <div class="invalid-feedback">{{ errors.disponibilite }}</div>
                </div>
              </div>

              <div class="text-end">
                <button type="submit" class="btn btn-primary" :disabled="loading">
                  <span v-if="loading" class="spinner-border spinner-border-sm me-2"></span>
                  Mettre à jour
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UserProfile',
  
  inject: ['ToastSuccess', 'ToastError'],
  
  data() {
    return {
      user: {},
      formData: {
        date_naissance: '',
        adresse: '',
        presentation: '',
        disponibilite: ''
      },
      errors: {},
      loading: false
    }
  },

  async created() {
    await this.loadProfile()
  },

  methods: {
    async loadProfile() {
      try {
        const response = await this.$http.get('/profile')
        this.user = response.data.profile
        
        // Remplir le formulaire avec les données existantes
        this.formData = {
          date_naissance: this.user.date_naissance || '',
          adresse: this.user.adresse || '',
          presentation: this.user.presentation || '',
          disponibilite: this.user.disponibilite || ''
        }
      } catch (error) {
        this.ToastError.fire({
          title: "Erreur lors du chargement du profil"
        })
      }
    },

    async updateProfile() {
      this.loading = true
      this.errors = {}

      try {
        const response = await this.$http.put('/profile', this.formData)
        this.user = response.data.profile
        this.ToastSuccess.fire({
          title: "Profil mis à jour avec succès"
        })
      } catch (error) {
        if (error.response?.status === 422) {
          this.errors = error.response.data.errors
          this.ToastError.fire({
            title: "Veuillez corriger les erreurs dans le formulaire"
          })
        } else {
          this.ToastError.fire({
            title: error.response?.data?.message || "Erreur lors de la mise à jour du profil"
          })
        }
      } finally {
        this.loading = false
      }
    }
  }
}
</script> 